import { useTranslation } from "react-i18next";
import { Button, Row } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import EventDateService from "../../../services/srv-event/EventDateService";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { useState } from "react";
import { TIMEZONE } from "../../../config/globalVariables";
import { getLocalDate } from "../../../utils/common";

export const EventDateAdd = (props) => {
  const { t } = useTranslation();
  const [data, setData] = useState({});

  const onSubmit = () => {
    var newData = { ...data };
    newData.etkinliK_TANIM_ID = props.event.etkinliK_TANIM_ID;
    newData.sirA_NO = 0;
    if (props.mode === "add") {
      EventDateService.addEventDate(newData).then((data) => {
        props.toggleDialog();
        props.setIsAdded(true);
      });
    } else {
      EventDateService.updateEventDate(newData).then((data) => {
        props.toggleDialog();
        props.setIsAdded(true);
      });
    }
  };

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"60vh"}
      initialWidth={"30%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      <Row>
        <DateTimePicker
          id="baS_TAR"
          name="baS_TAR"
          label={t("start_date")}
          value={data.baS_TAR ? new Date(data.baS_TAR) : null}
          onChange={(e) =>
            setData({ ...data, baS_TAR: getLocalDate(e.value, TIMEZONE) })
          }
          required={true}
        />
      </Row>
      <Row>
        <DateTimePicker
          id="biT_TAR"
          name="biT_TAR"
          label={t("end_date")}
          value={data.biT_TAR ? new Date(data.biT_TAR) : null}
          onChange={(e) =>
            setData({ ...data, biT_TAR: getLocalDate(e.value, TIMEZONE) })
          }
          required={true}
        />
      </Row>

      <hr></hr>
      <Button color="primary" type="button" size="sm" onClick={onSubmit}>
        <i className="fa fa-save"></i> {t("save")}
      </Button>
    </Window>
  );
};
